// External Dependencies:
import React from 'react'
import { withRouter } from 'react-router-dom'

// Events:
const doPageTransition = document.createEvent( 'Event' )
doPageTransition.initEvent( 'doPageTransition', true, true )

const doPageTransitionLeftToRight = document.createEvent( 'Event' )
doPageTransitionLeftToRight.initEvent( 'doPageTransitionLeftToRight', true, true )

const doPageTransitionRightToLeft = document.createEvent( 'Event' )
doPageTransitionRightToLeft.initEvent( 'doPageTransitionRightToLeft', true, true )

class Link extends React.Component {
	handleClick = ( e ) => {
		e.preventDefault()

		const editorIsOpen = document.documentElement.classList.contains( 'with-editor-open' )

		if ( editorIsOpen ) {
			return
		}

		const { history, to, onClick, transitionType, className = '' } = this.props
		let { transitionPrefix } = this.props

		if ( ! transitionPrefix ) {
			transitionPrefix = 'page'
		}

		if ( onClick ) {
			onClick( e )
		}

		// Maybe adjust colours:
		if ( className.includes( 'is-website' ) || className.includes( 'is-section-default' ) ) {
			document.documentElement.classList.add( 'content-type-website' )
			document.documentElement.classList.remove( 'content-type-branding' )
			document.documentElement.classList.remove( 'content-type-graphic_design' )
		} else if ( className.includes( 'is-branding' ) ) {
			document.documentElement.classList.remove( 'content-type-website' )
			document.documentElement.classList.add( 'content-type-branding' )
			document.documentElement.classList.remove( 'content-type-graphic_design' )
		} else if ( className.includes( 'is-graphic_design' ) ) {
			document.documentElement.classList.remove( 'content-type-website' )
			document.documentElement.classList.remove( 'content-type-branding' )
			document.documentElement.classList.add( 'content-type-graphic_design' )
		} else {
			document.documentElement.classList.remove( 'content-type-website' )
			document.documentElement.classList.remove( 'content-type-branding' )
			document.documentElement.classList.remove( 'content-type-graphic_design' )
		}

		if ( 'leftToRight' == transitionType ) {
			window.dispatchEvent( doPageTransitionLeftToRight )
		} else if ( 'rightToLeft' == transitionType ) {
			window.dispatchEvent( doPageTransitionRightToLeft )
		} else {
			window.dispatchEvent( doPageTransition )
		}

		document.documentElement.classList.add( `has-transition-${transitionPrefix}-leaving` )

		setTimeout( () => {
			history.push( to )

			setTimeout( () => {
				document.documentElement.classList.remove( `has-transition-${transitionPrefix}-leaving` )
			}, 400 )
		}, 400 )
	}

	render() {
		let { children, to, className, activeClassName, fuzzyMatch, location } = this.props

		if ( ! className ) {
			className = ''
		}

		if ( activeClassName && fuzzyMatch && location.pathname.indexOf( to ) > -1 ) {
			className += ` ${activeClassName}`
		} else if ( activeClassName && location.pathname == to ) {
			className += ` ${activeClassName}`
		}

		return (
			<a href={ to } className={ className } onClick={ this.handleClick }>{ children }</a>
		)
	}
}

export default withRouter( Link )



// WEBPACK FOOTER //
// ./components/Link/Link.jsx